import ModuleWrapperHeader from "./ModuleWrapperHeader";

export default ModuleWrapperHeader;